import { render, staticRenderFns } from "./WhatsappTemplatePost.vue?vue&type=template&id=67710cae"
import script from "./WhatsappTemplatePost.vue?vue&type=script&lang=js"
export * from "./WhatsappTemplatePost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports